import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import {AngularFireAuth} from '@angular/fire/auth';
import {AuthServiceService} from '../auth/auth-service.service';
import {ApiServiceService} from '../Service/api-service.service';


@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css']
})
export class ProfilComponent implements OnInit {

  allProfil = [];
  userDB = firebase.database().ref('/users');
  candidate: any;

  yourProfil = {
    username: '',
    country : '',
    favCandidate: ''
  };

  constructor(private afAuth: AngularFireAuth,
              public authenticationService: AuthServiceService,
              private apiServiceService: ApiServiceService) {
  }


  getAllProfil() {
    console.log('rentre');

    const promise = new Promise((resolve, reject) => {
      this.userDB.orderByChild('uid').once('value', (snapshot) => {
        const userdata = snapshot.val();
        const temparr = [];

        for (const key in userdata) { // key : uid d'un user

          console.log(key);
          temparr.push(userdata);

          if (this.afAuth.auth.currentUser.uid === key) {

            this.yourProfil.username = userdata[key].displayName;
            this.yourProfil.country = userdata[key].country;
            this.yourProfil.favCandidate = userdata[key].favCandidate;
            this.apiServiceService.getDetailSearch(this.yourProfil.favCandidate)
                .subscribe(candidate => this.candidate = candidate['results']);
          }
        }

      });
    });
  }

  getCandidate(id: string): void {
    this.apiServiceService.getDetailSearch(id).subscribe(candidate => this.candidate = candidate['results']);
  }


  signOut() {
    this.authenticationService.SignOut();
  }
  ngOnInit() {
    this.getAllProfil();
   }


}
